// extracted by mini-css-extract-plugin
export var modalFooter = "_j1-0";